import { CoordinatesAbbv as Coordinates } from 'store/types/geolocation'

export const googleapis = async (coordinates: Coordinates) => {
  const urlParams = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coordinates.lat},${coordinates.lon}&key=${process.env.GOOGLE_MAPS_KEY}`
  return fetch(urlParams)
    .then((response) => response.json())
    .then((res) => {
      let country: Record<'code' | 'name', string | null> = { code: null, name: null }
      let found = false

      if (res?.results?.length) {
        res.results.forEach((result: any) => {
          if (found) {
            return
          }

          const countryComponent = result?.address_components?.find((component: any) =>
            component.types.includes('country'),
          )

          if (countryComponent) {
            country = {
              code: countryComponent.short_name,
              name: countryComponent.long_name,
            }
            found = true
          }
        })
      }

      return {
        country,
      }
    })
}
